var whenDOMReady = require('../utils/when-dom-ready');
var searchInit = require('../components/search');

whenDOMReady(searchInit);
